import './helpers/globals';
import rimg from '@pixelunion/rimg-shopify';
import ShopifySectionsManager from '@pixelunion/shopify-sections-manager';

// Sections

import VideoSection from '@pixelunion/pxs-video';
import Product from './sections/Product';
import ProductRecommendations from './sections/ProductRecommendations';
import Slideshow from './sections/Slideshow';
import Map from './sections/Map';
import Testimonial from './sections/Testimonial';
import BlogPosts from './sections/BlogPosts';
import FeaturedCollection from './sections/Collection';
import Gallery from './sections/Gallery';
import Header from './sections/Header';
import Cart from './sections/Cart';
import Footer from './sections/Footer';

// Pages

import CollectionPage from './pages/Collection';
import BlogPage from './pages/Blog';
import ArticlePage from './pages/Article';
import SearchPage from './pages/Search';
import StaticPage from './pages/StaticPage';

// Components

import Tabs from './components/Tabs';
import Accordion from './components/Accordion';
import PredictiveSearch from './components/PredictiveSearch';
import CartDrawer from './components/CartDrawer';
import Modal from './components/Modal';
import NewsletterPopup from './components/NewsletterPopup';

// Helpers

import flickityTouchFix from './helpers/flickityTouchFix';

rimg.init();
new Tabs();
new Accordion();

if (Shopify.theme_settings.newsletter_popup === true) {
  new NewsletterPopup();
}

if (Shopify.theme_settings.enable_autocomplete === true) {
  new PredictiveSearch();
}

window.modal = new Modal();

const sections = new ShopifySectionsManager();

sections.register('site-header', section => new Header(section));
sections.register('product', section => new Product(section));
sections.register('product-recommendations', section => new ProductRecommendations(section));
sections.register('map', section => new Map(section));
sections.register('pxs-slideshow', section => new Slideshow(section));
sections.register('testimonial', section => new Testimonial(section));
sections.register('blog-posts', section => new BlogPosts(section));
sections.register('featured-collection', section => new FeaturedCollection(section));
sections.register('pxs-video', section => new VideoSection(section));
sections.register('gallery', section => new Gallery(section));
sections.register('cart', section => new Cart(section));
sections.register('site-footer', section => new Footer(section));
sections.register('collection-page', section => new CollectionPage(section));
sections.register('blog-page', section => new BlogPage(section));
sections.register('article-page', section => new ArticlePage(section));
sections.register('search-page', section => new SearchPage(section));
sections.register('static-page', section => new StaticPage(section));

if (Shopify.theme_settings.cart_action_type === 'ajax') {
  new CartDrawer();
}

flickityTouchFix();
